import { render, staticRenderFns } from "./ExercisesList.vue?vue&type=template&id=d27b8a88&scoped=true"
import script from "./ExercisesList.vue?vue&type=script&lang=js"
export * from "./ExercisesList.vue?vue&type=script&lang=js"
import style0 from "./ExercisesList.vue?vue&type=style&index=0&id=d27b8a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27b8a88",
  null
  
)

export default component.exports